import { render, staticRenderFns } from "./customerSearch.vue?vue&type=template&id=4fbbe928&scoped=true"
import script from "./customerSearch.vue?vue&type=script&lang=js"
export * from "./customerSearch.vue?vue&type=script&lang=js"
import style0 from "./customerSearch.vue?vue&type=style&index=0&id=4fbbe928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbbe928",
  null
  
)

export default component.exports